import store from "@/state/store";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  // {
  //   path: "/register",
  //   name: "Register",
  //   component: () => import("../views/account/register.vue"),
  //   meta: {
  //     title: "Register",
  //     beforeResolve(routeTo, routeFrom, next) {
  //       // If the user is already logged in
  //       if (store.getters["auth/loggedIn"]) {
  //         // Redirect to the home page instead
  //         next({ name: "default" });
  //       } else {
  //         // Continue to the login page
  //         next();
  //       }
  //     },
  //   },
  // },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/",
    name: "DashBoard",
    meta: { title: "Dashboard" },
    component: () => import("../pages/dashboard/index"),
  },
  {
    path: "/otp",
    name: "otp verification",
    meta: {
      title: "OTP Verification",
    },
    component: () => import("../views/account/OTP.vue"),
  },
  {
    name: "resetPassword",
    path: "/resetpassword",
    meta: {
      title: "Reset Password",
    },
    component: () => import("../views/account/reset-password.vue"),
  },
  {
    path: "/users",
    name: "Users",
    meta: { title: "Users", requiredPermission: "canManageUsers" },
    component: () => import("../pages/users/Users.vue"),
  },
  {
    path: "/user-settings",
    name: "User Settings",
    meta: { title: "User Settings" },
    component: () => import("../pages/users/Settings.vue"),
  },
  {
    path: "/permissions",
    name: "Permissions",
    meta: { title: "Permissions", requiredPermission: "canUpdatePermissions" },
    component: () => import("../pages/users/Permissions.vue"),
  },
  {
    path: "/create",
    name: "Create Users",
    meta: { title: "Create User", requiredPermission: "canManageUsers" },
    component: () => import("../pages/users/CreateUsers.vue"),
  },
  {
    path: "/user/edit/:id/",
    name: "Edit Users",
    meta: { title: "Edit User", requiredPermission: "canManageUsers" },
    component: () => import("../pages/users/Edit.vue"),
  },
  {
    path: "/user/profile/:id",
    name: "Profile",
    meta: { title: "Profile", requiredPermission: "canManageUsers" },
    component: () => import("../pages/users/Profile.vue"),
    children:[
        {
          path: "user-permission",
          name: "userpermission",
          meta: {
            title: "userpermission",
            requiredPermission: 'canUpdatePermissions',
          },
          component: () => import("../pages/users/UserPermissions.vue"),
        },
        {
          path: "",
          name: "useroverview",
          meta: {
            title: "overview",
            requiredPermission: 'canManageUsers',
          },
          component: () => import("../pages/users/Overview.vue"),
        },
    ]
  },

  
  {
    path: "/products",
    name: "List of Products",
    meta: { title: "Products", requiredPermission: "canManageProducts" },
    component: () => import("../pages/products/Product.vue"),
  },
  {
    path: "/products/:id",
    name: "Product Detail",
    meta: { title: "Product Detail", requiredPermission: "canManageProducts" },
    component: () => import("../pages/products/ProductDetail.vue"),
  },
  {
    path: "/sell_products",
    name: "Sell of Products",
    meta: { title: "Sell Products", requiredPermission: "canSellProducts" },
    component: () => import("../pages/products/SellProduct.vue"),
  },
  {
    path: "/categories",
    name: "List of Categories",
    meta: { title: "Categories", requiredPermission: "canManageCategories" },
    component: () => import("../pages/category/Categories.vue"),
  },
  {
    path: "/suppliers",
    name: "List of Suppliers",
    meta: { title: "Suppliers", requiredPermission: "canManageSuppliers" },
    component: () => import("../pages/supplier/Suppliers.vue"),
  },
  {
    path: "/supplier/supplys/:id",
    name: "Supplier supplies",
    meta: { title: "Supplier Supplies", requiredPermission: "canManageSuppliers" },
    component: () => import("../pages/supplier/Supplys.vue"),
  },
  {
    path: "/category/:id/:name",
    name: "List of Categories products",
    meta: { title: "Category Products", requiredPermission: "canManageCategories" },
    component: () => import("../pages/category/Products.vue"),
  },
   
  {
    path: "/wharehouse",
    name: "List of Wharehouses",
    meta: { title: "Warehouses", requiredPermission: "canManageWarehouses" },
    component: () => import("../pages/wharehouse/Wharehouses.vue"),
  },
  {
    path: "/wproducts/:id/:name",
    name: "List of Wharehouse Products",
    meta: { title: "Warehouse Products", requiredPermission: "canManageWarehouses" },
    component: () => import("../pages/wharehouse/WharehouseProducts.vue"),
  },
  {
    path: "/swharehouse/:id",
    name: "Product Location",
    meta: { title: "Product Location", requiredPermission: "canManageWarehouses" },
    component: () => import("../pages/wharehouse/SWharehouse.vue"),
  },
  {
    path: "/transfer/:id/:quantity/:w_id",
    name: "Wharehouse Product Transfer",
    meta: { title: "Transfer Product", requiredPermission: "canTransferProducts" },
    component: () => import("../pages/wharehouse/TransferPage.vue"),
  },
  {
    path: "/transfer-history",
    name: "Transfer History",
    meta: { title: "Transfer History", requiredPermission: "canTransferProducts" },
    component: () => import("../pages/wharehouse/TransferHistoryPage.vue"),
  },
  {
    path: "/stock-count",
    name: "Stock Count",
    meta: { title: "Stock Count", requiredPermission: "canManageStockCount" },
    component: () => import("../pages/wharehouse/StockCountPage.vue"),
  },
  {
    path: "/stock-count/:id",
    name: "Stock Count Detail",
    meta: { title: "Stock Count Detail", requiredPermission: "canManageStockCount" },
    component: () => import("../pages/wharehouse/StockCountDetailPage.vue"),
  },


  {
    path: "/purchase",
    name: "Purchase Product",
    meta: { title: "Purchase", requiredPermission: "canManagePurchases" },
    component: () => import("../pages/purchase/Purchase.vue"),
  },
  {
    path: "/p-list",
    name: "Purchase List",
    meta: { title: "Purchase List", requiredPermission: "canManagePurchases" },
    component: () => import("../pages/purchase/PurchaseList.vue"),
  },
  {
    path: "/p-product-list/:id",
    name: "Purchase Product List",
    meta: { title: "Purchase Products", requiredPermission: "canManagePurchases" },
    component: () => import("../pages/purchase/PListProducts.vue"),
  },
  {
    path: "/order-list",
    name: "Order List",
    meta: { title: "Order List", requiredPermission: "canManagePurchases" },
    component: () => import("../pages/purchase/OrderList.vue"),
  },
  {
    path: "/customers",
    name: "Customer Index",
    meta: { title: "Customers", requiredPermission: "canManageCustomers" },
    component: () => import("../pages/customers/customers.vue"),
  },
  {
    path: "/customer_with_balances",
    name: "Customer With Balances",
    meta: { title: "Customer Balances", requiredPermission: "canManageCustomers" },
    component: () => import("../pages/customers/CustomersWithBalances.vue"),
  },
  {
    path: "/customer-payments/:id",
    name: "Customer Payments",
    meta: { title: "Customer Payments", requiredPermission: "canManageCustomers" },
    component: () => import("../pages/customers/CustomerPayments.vue"),
  },
  {
    path: "/customer-profile/:id/:name",
    name: "Customer Profiles",
    meta: { title: "Customer Profile", requiredPermission: "canManageCustomers" },
    component: () => import("../pages/customers/profile.vue"),
  },
  //personnel
  {
    path: "/personnel",
    name: "Personnel",
    meta: { title: "Personnel", requiredPermission: "canManagePersonnel" },
    component: () => import("../pages/personnel/Personnel.vue"),
  },
  {
    path: "/personnel/:id",
    name: "PersonnelProfile",
    meta: { title: "Personnel Profile", requiredPermission: "canManagePersonnel" },
    component: () => import("../pages/personnel/PersonnelProfile.vue"),
  },
  {
    path: "/departments",
    name: "Departments",
    meta: { title: "Departments", requiredPermission: "canManageDepartments" },
    component: () => import("../pages/personnel/Departments.vue"),
  },

  //expenses
  {
    path: "/expenses",
    name: "Expenses",
    meta: { title: "Expenses", requiredPermission: "canManageExpenses" },
    component: () => import("../pages/expenses/ExpenseTracking.vue"),
  },
  {
    path: "/expense-category",
    name: "Expense Categories",
    meta: { title: "Expense Categories", requiredPermission: "canManageExpenses" },
    component: () => import("../pages/expenses/ExpenseCategory.vue"),
  },

  //reports
  {
    path: "/stock-report",
    name: "Stock Reports",
    meta: { title: "Stock Report", requiredPermission: "canViewStockReport" },
    component: () => import("../pages/reports/Stock.vue"),
  },
  {
    path: "/accounting",
    name: "Accounting",
    meta: { title: "Accounting", requiredPermission: "canManageReports" },
    component: () => import("../pages/accounting/Accounting.vue"),
  },
  {
    path: "/sale-report",
    name: "sale Reports",
    meta: { title: "Sale Report", requiredPermission: "canManageReports" },
    component: () => import("../pages/reports/SaleReport.vue"),
  },
  {
    path: "/my-sales",
    name: "My Reports",
    meta: { title: "My Sales", requiredPermission: "canManageSales" },
    component: () => import("../pages/reports/MySales.vue"),
  },
  {
    path: "/purchase-report",
    name: "purchase Reports",
    meta: { title: "Purchase Report", requiredPermission: "canManagePurchases" },
    component: () => import("../pages/reports/PurchaseReport.vue"),
  },
  {
    path: "/summery-report",
    name: "Summery Reports",
    meta: { title: "Summary Report", requiredPermission: "canManageReports" },
    component: () => import("../pages/reports/SummeryReport.vue"),
  },

  //settings
  {
    path: "/tables",
    name: "List of Tables",
    meta: { title: "Tables Settings", requiredPermission: "canManageSettings" },
    component: () => import("../pages/settings/tables/Tables.vue"),
  },
  {
    path: "/payment-methods",
    name: "List of Methods",
    meta: { title: "Payment Methods", requiredPermission: "canManageSettings" },
    component: () => import("../pages/settings/payment_methods/Methods.vue"),
  },
  {
    path: "/units",
    name: "List of units",
    meta: { title: "Units", requiredPermission: "canManageSettings" },
    component: () => import("../pages/settings/units/Units.vue"),
  },
  {
    path: "/tax",
    name: "List of tax",
    meta: { title: "Tax Settings", requiredPermission: "canManageSettings" },
    component: () => import("../pages/settings/tax/Tax.vue"),
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout", authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.clear();
        sessionStorage.clear();
        next();
      },
    },
    component: () => import("../views/auth/logout/basic")
  },
  {
    path: "/dashboard",
    name: "default",
    meta: { title: "Dashboard" },
    component: () => import("../pages/dashboard/index"),
  },
  {
    path: "/app-settings",
    name: "app-settings",
    meta: { title: "App Settings", requiredPermission: "canManageSettings" },
    component: () => import("../pages/AppSettings"),
  },
  {
    path: "/license",
    name: "license",
    meta: { title: "License & Billing", requiredPermission: "canManageSettings" },
    component: () => import("../pages/settings/license/License.vue"),
  },
  {
    path: "/help",
    name: "help",
    meta: { title: "Help Center" },
    component: () => import("../pages/help/Help.vue"),
  },
  {
    path: "/offline",
    name: "offline",
    meta: { title: "Offline & Sync", requiredPermission: "canManageSettings" },
    component: () => import("../pages/settings/offline/Offline.vue"),
  },
  {
    path: "/onboarding",
    name: "onboarding",
    meta: { title: "Setup Wizard", requiredPermission: "canManageSettings" },
    component: () => import("../pages/Onboarding.vue"),
  },
  {
    path: "/roles",
    name: "roles",
    meta: { title: "Roles & Permissions", requiredPermission: "canUpdatePermissions" },
    component: () => import("../pages/users/Roles.vue"),
  },
  {
    path: "/activities",
    name: "activities",
    meta: { title: "Activities", requiredPermission: "canViewActivityLog" },
    component: () => import("../pages/ActivitiesPage"),
  },
  
  // ── Distribution Module ─────────────────────────────────────────────────
  {
    path: "/vehicles",
    name: "Vehicles",
    meta: { title: "Vehicles", requiredPermission: "canManageDistributions" },
    component: () => import("../pages/distribution/VehiclesPage.vue"),
  },
  {
    path: "/vehicles/:id",
    name: "VehicleDetail",
    meta: { title: "Vehicle Details", requiredPermission: "canManageDistributions" },
    component: () => import("../pages/distribution/VehicleDetail.vue"),
  },
  {
    path: "/drivers",
    name: "Drivers",
    meta: { title: "Drivers", requiredPermission: "canManageDrivers" },
    component: () => import("../pages/distribution/DriversPage.vue"),
  },
  {
    path: "/distribution-settings",
    name: "Distribution Settings",
    meta: { title: "Distribution Settings", requiredPermission: "canManageDistributions" },
    component: () => import("../pages/distribution/DistributionSettings.vue"),
  },
  {
    path: "/driver-performance",
    name: "Driver Performance",
    meta: { title: "Driver Performance", requiredPermission: "canManageDrivers" },
    component: () => import("../pages/distribution/DriverPerformancePage.vue"),
  },
  {
    path: "/distribution",
    name: "Distribution",
    meta: { title: "Gas Distribution", requiredPermission: "canManageDistributions" },
    component: () => import("../pages/distribution/DistributionPage.vue"),
  },
  {
    path: "/distribution/:id",
    name: "DistributionDetail",
    meta: { title: "Distribution Detail", requiredPermission: "canManageDistributions" },
    component: () => import("../pages/distribution/DistributionDetail.vue"),
  },
  {
    path: "/depot",
    name: "Depot",
    meta: { title: "Depot Stock", requiredPermission: "canManageDistributions" },
    component: () => import("../pages/distribution/DepotPage.vue"),
  },
  {
    path: "/depot-finance",
    redirect: "/accounting",
  },

  {
    path: '/auth/signin-basic',
    name: 'signin-basic',
    meta: {
      title: "Signin Basic", authRequired: false,
    },
    component: () => import('../views/auth/signin/basic')
  },
  {
    path: '/auth/signin-cover',
    name: 'signin-cover',
    meta: {
      title: "Signin Cover", authRequired: false,
    },
    component: () => import('../views/auth/signin/cover')
  },
  {
    path: '/auth/signup-basic',
    name: 'signup-basic',
    meta: {
      title: "Signup Basic", authRequired: false,
    },
    component: () => import('../views/auth/signup/basic')
  },
  {
    path: '/auth/signup-cover',
    name: 'signup-cover',
    meta: {
      title: "Signup Cover", authRequired: false,
    },
    component: () => import('../views/auth/signup/cover')
  },
  {
    path: '/auth/reset-pwd-basic',
    name: 'reset-pwd-basic',
    meta: {
      title: "Reset Password", authRequired: false,
    },
    component: () => import('../views/auth/reset/basic')
  },
  {
    path: '/auth/reset-pwd-cover',
    name: 'reset-pwd-cover',
    meta: {
      title: "Reset Password", authRequired: false,
    },
    component: () => import('../views/auth/reset/cover')
  },
  {
    path: '/auth/create-pwd-basic',
    name: 'create-pwd-basic',
    meta: {
      title: "create Password", authRequired: false,
    },
    component: () => import('../views/auth/create/basic')
  },
  {
    path: '/auth/create-pwd-cover',
    name: 'create-pwd-cover',
    meta: {
      title: "create Password", authRequired: false,
    },
    component: () => import('../views/auth/create/cover')
  },
  {
    path: '/auth/lockscreen-basic',
    name: 'lock-screen-basic',
    meta: {
      title: "Lock Screen", authRequired: false,
    },
    component: () => import('../views/auth/lockscreen/basic')
  },
  {
    path: '/auth/lockscreen-cover',
    name: 'lock-screen-cover',
    meta: {
      title: "Lock Screen", authRequired: false,
    },
    component: () => import('../views/auth/lockscreen/cover')
  },
  {
    path: '/auth/twostep-basic',
    name: 'twostep-basic',
    meta: {
      title: "Two Step Auth", authRequired: false,
    },
    component: () => import('../views/auth/twostep/basic')
  }, {
    path: '/auth/twostep-cover',
    name: 'twostep-cover',
    meta: {
      title: "Two Step Auth", authRequired: false,
    },
    component: () => import('../views/auth/twostep/cover')
  },
  {
    path: '/auth/404',
    name: '404',
    meta: {
      title: "Error 404", authRequired: false,
    },
    component: () => import('../views/auth/errors/404')
  },
  {
    path: '/auth/403',
    name: '403',
    meta: {
      title: "Error 403", authRequired: false,
    },
    component: () => import('../views/auth/errors/403')
  },
  {
    path: '/auth/500',
    name: '500',
    meta: {
      title: "Error 500", authRequired: false,
    },
    component: () => import('../views/auth/errors/500')
  },
  {
    path: '/auth/404-basic',
    name: '404-basic',
    meta: {
      title: "Error 404", authRequired: false,
    },
    component: () => import('../views/auth/errors/404-basic')
  },
  {
    path: '/auth/404-cover',
    name: '404-cover',
    meta: {
      title: "Error 404", authRequired: false,
    },
    component: () => import('../views/auth/errors/404-cover')
  },
  {
    path: '/auth/ofline',
    name: 'ofline',
    meta: {
      title: "Offline", authRequired: false,
    },
    component: () => import('../views/auth/errors/ofline')
  },
  {
    path: '/auth/logout-basic',
    name: 'logout-basic',
    meta: {
      title: "Logout", authRequired: false,
    },
    component: () => import('../views/auth/logout/basic')
  },
  {
    path: '/auth/logout-cover',
    name: 'logout-cover',
    meta: {
      title: "Logout", authRequired: false,
    },
    component: () => import('../views/auth/logout/cover')
  },
  {
    path: '/auth/success-msg-basic',
    name: 'success-msg-basic',
    meta: {
      title: "Success Message", authRequired: false,
    },
    component: () => import('../views/auth/success-msg/basic')
  },
  {
    path: '/auth/success-msg-cover',
    name: 'success-msg-cover',
    meta: {
      title: "Success Message", authRequired: false,
    },
    component: () => import('../views/auth/success-msg/cover')
  },
 
];